import { toast } from "react-toastify";
import { ProfileConstant } from "../constants/profileConstant";

export const SocialAddAction = (payload) => (dispatch) => {
  dispatch({
    type: ProfileConstant.CREATE_SOCIAL_SUCCESS,
    payload,
  });
  toast.success("Add social link", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    theme: "dark",
  });
};
